import { z } from 'zod';
import { VALIDATION_PATTERNS, ERROR_MESSAGES } from 'src/contstant/commonLabels';
import { isHtmlContentEmpty } from 'src/validations/translationFormSchema';

/**
 * Zod validation schema for the TaskDraftForm component.
 * Validates editable form fields for task draft creation/editing.
 */
export const taskDraftFormSchema = z.object({
  taskName: z.string().min(1, { message: 'Task name is required' }),
  taskDurationDays: z.coerce
    .number()
    .min(1, { message: 'Task duration must be at least 1 day' }),
  taskDescription: z.string().refine((val) => !isHtmlContentEmpty(val), {
    message: 'Task description is required',
  }),
  assignee: z
    .string()
    .min(1, { message: 'Assignee is required' })
    .regex(VALIDATION_PATTERNS.ASSIGNEE_ALIAS, {
      message: ERROR_MESSAGES.ASSIGNEE_AT_SYMBOL,
    }),
  auditorObservation: z.string().optional().default(''),
});

export type TaskDraftFormData = z.infer<typeof taskDraftFormSchema>;
